import "firebase/analytics";
import Utility from "@/shared/utility";
import axios from "axios";
import Registrant from "./Registrant";
import {setYourBusinessNetworkDoc} from "@/shared/firebase_utils";

class YourBusinessNetwork {
  constructor({
    id = "",
    businessProfileId = "",
    eventName = "",
    privacyPolicyURL = "",
    qrCodeURL = "",
    isNameRequired = true,
    isNameSwitchedOn = true,
    isCityRequired = true,
    isCitySwitchedOn = true,
    isCountryRequired = true,
    isCountrySwitchedOn = true,
    isEmailRequired = true,
    isEmailSwitchedOn = true,
    isMobileRequired = true,
    isMobileSwitchedOn = true,
    isBusinessNameRequired = false,
    isBusinessNameSwitchedOn = true,
    isJobTitleRequired = false,
    isJobTitleSwitchedOn = true,
    isNoteRequired = false,
    isNoteSwitchedOn = false,
    linkedFormURL = "",
    noOfRegistrants = 0,
    createdBy = "",
    created = null,
    dynamicLink = "",
    registrants = [] 
  }) {
    (this.id = id),
      (this.businessProfileId = businessProfileId),
      (this.eventName = eventName),
      (this.privacyPolicyURL = privacyPolicyURL),
      (this.qrCodeURL = qrCodeURL),
      (this.isNameRequired = isNameRequired),
      (this.isNameSwitchedOn = isNameSwitchedOn),
      (this.isCityRequired = isCityRequired),
      (this.isCitySwitchedOn = isCitySwitchedOn),
      (this.isCountryRequired = isCountryRequired),
      (this.isCountrySwitchedOn = isCountrySwitchedOn),
      (this.isEmailRequired = isEmailRequired),
      (this.isEmailSwitchedOn = isEmailSwitchedOn),
      (this.isMobileRequired = isMobileRequired),
      (this.isMobileSwitchedOn = isMobileSwitchedOn),
      (this.isBusinessNameRequired = isBusinessNameRequired),
      (this.isBusinessNameSwitchedOn = isBusinessNameSwitchedOn),
      (this.isJobTitleRequired = isJobTitleRequired),
      (this.isJobTitleSwitchedOn = isJobTitleSwitchedOn),
      (this.isNoteRequired = isNoteRequired),
      (this.isNoteSwitchedOn = isNoteSwitchedOn),
      (this.linkedFormURL = linkedFormURL),
      (this.noOfRegistrants = noOfRegistrants),
      (this.createdBy = createdBy),
      (this.created = created),
      (this.dynamicLink = dynamicLink);
      (this.registrants = registrants)
  }
  toFirestore() {
    return {
      id: this.id,
      businessProfileId: this.businessProfileId,
      eventName: this.eventName,
      privacyPolicyURL: this.privacyPolicyURL,
      qrCodeURL: this.qrCodeURL,
      isNameRequired: this.isNameRequired,
      isNameSwitchedOn: this.isNameSwitchedOn,
      isCityRequired: this.isCityRequired,
      isCitySwitchedOn: this.isCitySwitchedOn,
      isCountryRequired: this.isCountryRequired,
      isCountrySwitchedOn: this.isCountrySwitchedOn,
      isEmailRequired: this.isEmailRequired,
      isEmailSwitchedOn: this.isEmailSwitchedOn,
      isMobileRequired: this.isMobileRequired,
      isMobileSwitchedOn: this.isMobileSwitchedOn,
      isBusinessNameRequired: this.isBusinessNameRequired,
      isBusinessNameSwitchedOn: this.isBusinessNameSwitchedOn,
      isJobTitleRequired: this.isJobTitleRequired,
      isJobTitleSwitchedOn: this.isJobTitleSwitchedOn,
      isNoteRequired: this.isNoteRequired,
      isNoteSwitchedOn: this.isNoteSwitchedOn,
      linkedFormURL: this.linkedFormURL,
      noOfRegistrants: this.noOfRegistrants,
      createdBy: this.createdBy,
      created: this.created,
      dynamicLink: this.dynamicLink,
      registrants:this.registrants?.map((registrant) => registrant.toObject()) || [],
    };
  }

  static fromFireStore(documentSnapshot) {
    let data = documentSnapshot.data();
    return new YourBusinessNetwork({
      id: documentSnapshot.id,
      businessProfileId: data.businessProfileId,
      eventName: data.eventName,
      privacyPolicyURL: data.privacyPolicyURL,
      qrCodeURL: data.qrCodeURL,
      isNameRequired: data.isNameRequired,
      isNameSwitchedOn: data.isNameSwitchedOn,
      isCityRequired: data.isCityRequired,
      isCitySwitchedOn: data.isCitySwitchedOn,
      isCountryRequired: data.isCountryRequired,
      isCountrySwitchedOn: data.isCountrySwitchedOn,
      isEmailRequired: data.isEmailRequired,
      isEmailSwitchedOn: data.isEmailSwitchedOn,
      isMobileRequired: data.isMobileRequired,
      isMobileSwitchedOn: data.isMobileSwitchedOn,
      isBusinessNameRequired: data.isBusinessNameRequired,
      isBusinessNameSwitchedOn: data.isBusinessNameSwitchedOn,
      isJobTitleRequired: data.isJobTitleRequired,
      isJobTitleSwitchedOn: data.isJobTitleSwitchedOn,
      isNoteRequired: data.isNoteRequired,
      isNoteSwitchedOn: data.isNoteSwitchedOn,
      linkedFormURL: data.linkedFormURL,
      noOfRegistrants: data.noOfRegistrants,
      createdBy: data.createdBy,
      created: data.created,
      dynamicLink: data.dynamicLink,
      registrants: data.registrants?.map((registrant) => Registrant.fromObject(registrant)) || [],

    });
  }

  async save() {
    try {
      await setYourBusinessNetworkDoc(this.id, this.toFirestore());
    } catch (err) {
      console.log(
        "Error occurred while saving yourBusinessNetwork to firestore: ",
        err
      );
    }
  }

  async generatePublicLink() {
    console.log("called");
    let deepLink = `${Utility.webAppLinkPrefix()}yourBusinessNetwork/${
      this.id
    }`;

    let socialTitle = this.eventName;
    let socialDescription = "Your Business Network " + this.eventName;

    //Create a new business card document in firestore
    let payload = {
      dynamicLinkInfo: {
        domainUriPrefix: Utility.domainUriPrefix(),
        link: deepLink,
        androidInfo: {
          androidPackageName: Utility.androidPackageName(),
          androidFallbackLink: deepLink,
        },
        iosInfo: {
          iosBundleId: Utility.iOSBundleId(),
          iosAppStoreId: "1544309052",
          iosFallbackLink: deepLink,
          iPadFallbackLink: deepLink,
        },
        socialMetaTagInfo: {
          socialTitle: socialTitle,
          socialDescription: socialDescription,
          // socialImageLink:
          //   "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/appAssets%2FappLogos%2F1024.png?alt=media&token=0f25689b-da59-48e4-b3f2-c86fffaa2649",
          //socialImageLink: this.compressedCoverImageURL || "https://firebasestorage.googleapis.com/v0/b/pappyon-c59f8.appspot.com/o/appAssets%2FappLogos%2F1024.png?alt=media&token=0f25689b-da59-48e4-b3f2-c86fffaa2649"
        },
        navigationInfo: {
          enableForcedRedirect: true,
        },
      },
    };

    // Connect with the people attending ${this.name}.

    try{
      let res = await axios.post(
        `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${Utility.firebaseWebAPIKey()}`,
        payload
      );
      console.log("res: ", res);


      this.dynamicLink = "";
      if (res.status == 200) {
        this.dynamicLink = res.data.shortLink;
      }
    }catch(err){
      console.log("err : ", err);

    }
  }
}

export default YourBusinessNetwork;
